import React from 'react';

function LeftSideLayoutMain() {
  return <></>;
}

export default React.memo(LeftSideLayoutMain);
